import styled from 'styled-components';
import Stack from 'atoms/Layout/Stack/Stack';
import { cssVar } from 'styles/helper';

export const FrostedOverlayContainer = styled(Stack)`
  backdrop-filter: blur(12px);
  border: 1px solid ${cssVar('alpha-white-light-40')};
`;
